// Utility layer (TS-2.5.04) - pure, no side effects. Split out of FormField.tsx so that file can
// export only a component (react-refresh/only-export-components) - the id/aria-describedby/
// aria-invalid computation a control nested in a FormField needs, kept in one place so every call
// site derives it the same way.
export function formFieldControlProps(id: string, description?: string, error?: string | null) {
  const descriptionId = description ? `${id}-description` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [descriptionId, errorId].filter(Boolean).join(" ") || undefined;
  return {
    id,
    "aria-describedby": describedBy,
    "aria-invalid": Boolean(error) || undefined,
  } as const;
}
